import { useEffect, useState } from 'react';

import { OptionType } from '@shared/types/global';

import { SelectWithCheckbox } from './SelectWithCheckbox/SelectWithCheckbox';

type FilterSelectProps = {
  label: string;
  filterId: string;
  options: OptionType[];
  onChange: (value: OptionType[], filterId: string) => void;
  activeFilters: Record<string, string[] | number[] | boolean[]>;
};

export const FilterSelect = ({ label, filterId, onChange, options, activeFilters }: FilterSelectProps) => {
  const [actualOptions, setActualOptions] = useState<OptionType[]>(options);

  const onChangeHandler = (value: OptionType[]) => {
    setActualOptions(value);
    onChange(value, filterId);
  };

  useEffect(() => {
    if (activeFilters && activeFilters[filterId]) {
      const activeLabels = new Set(activeFilters[filterId].filter((el) => typeof el === 'string'));
      const currentOptions = options.map((item) =>
        activeLabels.has(item.label)
          ? {
              ...item,
              active: true
            }
          : item
      );
      setActualOptions(currentOptions);
      return;
    }
    setActualOptions(options);
  }, [activeFilters, filterId, options]);

  return (
    <SelectWithCheckbox
      options={actualOptions}
      onChange={onChangeHandler}
      label={label}
    />
  );
};
